import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Stack, Container, Typography, Grid, Card, Divider, Button, TextField } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { addDoc, collection, doc, updateDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import useGetUser from '../hooks/useGetUser';
import { fNumber } from '../utils/formatNumber';

function Payment() {

  const location = useLocation()
  const navigate = useNavigate()
  const data = location.state
  const user = useGetUser(auth.currentUser?.uid)
  const [post, setpost] = useState("")
  const EXCHANGE_RATE = 20.3

  const pay = async () =>{
 await addDoc(collection(db, `invoices`),  
    { 
      amount : data.bill, 
      reference : post,
      userId : auth.currentUser.uid, 
      package: data.package,
      duration : data.package === "BASIC" ? 31 : 365,
      createdAt:Date.now(),
       }).then(async()=>{
        await updateDoc(doc(db, "app_users",auth.currentUser.uid ),
         {
          account :  data.package,
          duration :  data.package === "BASIC" ? 31 : 365,
        }).then(()=>{
          console.log("account updated")
          navigate("/dashboard/profile")
        })
       });
  
  }

  return (
    <>
    <Helmet>
      <title>Payment</title>
    </Helmet>

    <Container>
      <Stack direction="row" alignItems="center" justifyContent="center" mb={5}>
        <Typography variant="h4" gutterBottom>
        Let's finish powering you up!
        </Typography>         
      </Stack>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
        <Card sx={{p:3}}>
        <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
                <Stack>
                  <Typography>Billing Address</Typography>
                  {auth.currentUser && user ? 
                  <Stack sx={{mt : 5}}>
                      <Typography>Full Name</Typography>
                      <Typography>{user.fullName}</Typography>
                      <Divider sx={{my:3}} />
                      <Typography>Phone Number</Typography>
                      <Typography>{user.phoneNumber}</Typography>
                      <Divider sx={{my:3}} />
                      <Typography>Current Account</Typography>
                      <Typography>{user.account}</Typography>                    
                  </Stack> : <Button variant='contained' size="large" color="success" sx={{mt:10}} onClick={()=>navigate("/login")}>Sign Up/in</Button>}
                </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
                <Stack>
                      <Typography>Payment Process</Typography>
                      <Typography sx={{my:2}}>Send K{fNumber(data.bill* EXCHANGE_RATE)} to any of the options below</Typography>
                      <Typography sx={{my:2}}>Airtel : +260978314539 or eWallet : +260978314539</Typography>
                      <Typography sx={{my:2}}>Once payment is complete, Enter your transaction ID/Ref below you will receive your invoice on your profile.</Typography>
                      <TextField
                          fullWidth  
                          type="text"
                          label="TXN ID / TX / Ref"
                          placeholder='For example MP123456.3456.Z12345'
                          value={post}
                          onChange={(event) => setpost(event.target.value)}
                        />
                    </Stack>
            </Grid>
        </Grid>
        </Card>
        </Grid>
        {auth.currentUser && <Grid item xs={12} md={4}>
          <Card sx={{p:3}}>
              <Stack>
                <Typography>Summary</Typography>
                <Divider sx={{my:3}} />
                <Typography>Package</Typography>
                <Typography variant='h2'>{data.package}</Typography>
                <Divider sx={{my:3}} />
                <Typography>Duration</Typography>
                <Typography variant='h2'>{data.package === "BASIC" ? "Monthly" : "Yearly"}</Typography>
                <Divider sx={{my:3}} />
                <Typography>Bill</Typography>
                <Typography sx={{textAlign:"right"}} variant='h2'>K{fNumber(data.bill* EXCHANGE_RATE)}</Typography>
                <Divider sx={{my:3}} />
                    <Button variant='contained' onClick={()=>pay()} disabled={post.length === 0} color='success' size="large">Update my Plan</Button>
              </Stack>
              </Card>
        </Grid>}
      </Grid>
    
    </Container>
  </>
  )
}

export default Payment